import React from 'react'
import PageContainer from '../../layout/PageContainer';
import CorredorLineaGarantiaList from './CorredorLineaGarantiaList';


const CorredorLineaGarantiaListContainer = () => (
  <PageContainer
    breadcrumbs={[
      { id: 0, name: 'SEGURO DE CRÉDITO', url: '/' },
      {id: 1, name: 'LÍNEAS GARANTÍA CARTERA CLIENTES' },
    ]}
    clientFilter={{
      type: 'corredor',
      ramo: 'garantia',
      showFilter: true,
    }}
  >
    {(corredor) => (
      <CorredorLineaGarantiaList corredor={corredor} />
    )}
  </PageContainer>
);

export default CorredorLineaGarantiaListContainer;
